// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__MFplG","teamLogo":"style_teamLogo__zgpeS","sold":"style_sold__ClJin"};